$(document).ready(function(){
  
  processVariantOrCurrencyChange()
  
  function processVariantOrCurrencyChange() {
    $('.discount-price-vanilla').text(getPriceWithCommas()).addClass('active')
  }
  
  $('body').on('change','.single-option-selector,.currencies',processVariantOrCurrencyChange)
  
  function formatPriceWithCommas(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  function getPriceWithCommas() {
    thePriceText       = $('.current_price').find('.money:not(.hidden)').text()
    
    currencyGlyph      = thePriceText.charAt(0)
    
    isolatedPrice      = thePriceText.replace(/&#165;|&euro;|&pound;|[$£€¥,]/g,'') // Removes any existing currency glyph
    
    discountPercentage = parseFloat($('.discount-price-vanilla').attr('data-discount-percentage'))
    
    finalPriceToReturn = currencyGlyph + formatPriceWithCommas((Math.round(isolatedPrice * discountPercentage * 100) / 100).toFixed(2))
    
    return finalPriceToReturn
  }
})